import React from "react";
import "./CustomDevelopmentDiscoveryMapping.css";

import customDevelopmentDiscoveryMappingLightBackground from "../../images/custom-development-discovery-mapping-light-background.svg";
import customDevelopmentDiscoveryMappingWorkspaceDesktop from "../../images/custom-development-discovery-mapping-workspace-desktop.svg";
import customDevelopmentDiscoveryMappingWorkspaceMobile from "../../images/custom-development-discovery-mapping-workspace-mobile.svg";

export default function CustomDevelopmentDiscoveryMapping({ discoveryHref = "#custom-development-scope" }) {
  return (
    <section className="custom-development-discovery-mapping" id="custom-development-discovery" aria-labelledby="custom-development-discovery-mapping-title">
      <img className="custom-development-discovery-mapping__background" src={customDevelopmentDiscoveryMappingLightBackground} alt="" aria-hidden="true" />
      <div className="custom-development-discovery-mapping__inner">
        <div className="custom-development-discovery-mapping__copy">
          <p className="custom-development-discovery-mapping__eyebrow">Discovery &amp; process mapping</p>
          <h2 id="custom-development-discovery-mapping-title">Find the real constraint before building the system.</h2>
          <p>We trace how work, information and decisions move through the operation — then define the first opportunity worth building.</p>
          <a className="custom-development-discovery-mapping__action" href={discoveryHref}><span>Start with discovery</span><span aria-hidden="true">→</span></a>
        </div>
        <picture className="custom-development-discovery-mapping__visual">
          <source media="(max-width: 699px)" srcSet={customDevelopmentDiscoveryMappingWorkspaceMobile} />
          <img src={customDevelopmentDiscoveryMappingWorkspaceDesktop} alt="Four-stage discovery workflow: observe, map, measure and define." />
        </picture>
        <div className="custom-development-discovery-mapping__deliverable">
          <span>Discovery deliverable</span>
          <strong>A shared, evidence-based system brief.</strong>
          <p>Process map · Data readiness · Prioritised use case · Delivery scope</p>
        </div>
      </div>
    </section>
  );
}
